/**
 * Texts for Factsheets page
 *
 * PDF DOWNLOAD INSTRUCTIONS:
 * Each factsheet has an image and a PDF download URL.
 * On image click, the PDF will be downloaded.
 * Simply edit the 'pdfUrl' field in each factsheet object below.
 */
export const factsheetsPageText = {
  title: "Factsheets - CamAPS FX",
  titleMeta: "CamAPS FX Factsheets - Quick reference guides",
  descriptionMeta:
    "Download helpful factsheets and guides for quick reference about CamAPS FX.",
  keywords:
    "camaps fx factsheets, camaps guides, diabetes app guides, insulin pump factsheets, cgm guides, pdf downloads",
  localeMeta: "da_dk",

  mainHeader: "Faktaark",
  mainSubHeader: "Download nyttige faktaark og vejledninger.",

    altHelp: 'Hjælp',
    altInfo: 'Info',
    altAppStore: 'Download i App Store',
    altGooglePlay: 'Hent den på Google Play',
    ariaGoToSlide: 'Gå til slide {n}',
    ariaNextSlide: 'Næste slide',
    ariaPrevSlide: 'Forrige slide',
    videoNotSupportedText: 'Din browser understøtter ikke video-tagget.',
    virtualModeTooltipText: 'Virtuel tilstand giver dig mulighed for at afprøve appen uden at være forbundet til en rigtig insulinpumpe og CGM-sensor.',
    closeButtonText: 'Luk',
    filterAll: 'Alle',
    filterYpsoPump: 'YpsoPump',
    filterDana: 'Dana',
    sortNewest: 'Nyeste',
    sortOldest: 'Ældste',
    sortAZ: 'A-Z',
    sortPopular: 'Mest populære',
  // Getting Started Section
  gettingStartedHeader: "Klar til at komme i gang?",
  step1Title: "<strong>Trin 1:</strong> Download appen",
  step2Title: "<strong>Trin 2:</strong> Opret en konto",
  step3Title: "<strong>Trin 3:</strong> Begynd den væsentlige træning i appen",
  step4Title: "<strong>Trin 4:</strong> Par din valgte pumpe og CGM (med godkendelse fra dit sundhedsteam) eller udforsk appen med <strong>Virtuel tilstand</strong>",

  // Support Section
  supportSectionTitle: "Har du brug for mere hjælp?",
  supportSectionText:
    "Vores supportteam er her for at hjælpe dig med eventuelle spørgsmål.",
  supportButtonText: "KONTAKT SUPPORT",

  factsheets: [
    // {
    //     id: 1,
    //     title: 'Linking CamAPS FX to Glooko',
    //     description: 'Linking CamAPS FX to Glooko',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-001.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-001-linking-glooko.pdf'
    // },
    // {
    //     id: 2,
    //     title: 'Generating a PDF report',
    //     description: 'Generating a PDF report',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-002.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-002-pdf-report.pdf'
    // },
    // {
    //     id: 3,
    //     title: 'Managing Hypos on CamAPS FX',
    //     description: 'Managing Hypos on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-003.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-003-managing-hypos.pdf'
    // },
    // {
    //     id: 4,
    //     title: 'Managing Illness on CamAPS FX',
    //     description: 'Managing Illness on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-004.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-004-managing-illness.pdf'
    // },
    // {
    //     id: 5,
    //     title: 'Managing Meals on CamAPS FX',
    //     description: 'Managing Meals on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-005.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-005-managing-meals.pdf'
    // },
    // {
    //     id: 6,
    //     title: 'Travelling with CamAPS FX',
    //     description: 'Travelling with CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-006.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-006-travelling.pdf'
    // },
    // {
    //     id: 7,
    //     title: 'Getting support on CamAPS FX',
    //     description: 'Getting support on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-007.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-007-getting-support.pdf'
    // },
    // {
    //     id: 8,
    //     title: 'Using CamAPS FX at school, nursery or in childcare',
    //     description: 'Using CamAPS FX at school, nursery or in childcare',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-008.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-008-at-school.pdf'
    // },
    // {
    //     id: 9,
    //     title: 'CamAPS FX School\'s Care Plan Template',
    //     description: 'CamAPS FX School\'s Care Plan Template',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-009.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-009-care-plan-template.docx'
    // },
    // {
    //     id: 10,
    //     title: 'Using CamAPS FX in virtual (demo) mode',
    //     description: 'Using CamAPS FX in virtual (demo) mode',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-010.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-010-demo-mode.pdf'
    // },
    // {
    //     id: 11,
    //     title: 'CamAPS FX and its Patency Pulse',
    //     description: 'CamAPS FX and its Patency Pulse',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-011.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-011-patency-pulse.pdf'
    // },
    // {
    //     id: 12,
    //     title: 'Having Surgery or a Procedure when using CamAPS FX',
    //     description: 'Having Surgery or a Procedure when using CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-012.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-012-surgery-procedure.pdf'
    // },
    // {
    //     id: 13,
    //     title: 'Managing Pregnancy on CamAPS FX',
    //     description: 'Managing Pregnancy on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-013.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-013-managing-pregnancy.pdf'
    // },
    // {
    //     id: 14,
    //     title: 'Optimising CamAPS FX',
    //     description: 'Optimising CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-014.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-014-optimising.pdf'
    // },
    // {
    //     id: 15,
    //     title: 'Starting CamAPS FX - training slide deck',
    //     description: 'Starting CamAPS FX - training slide deck',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-015.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-015-training-slides.pdf'
    // },
    // {
    //     id: 16,
    //     title: 'Preparing to start CamAPS FX',
    //     description: 'Preparing to start CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-016.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-016-preparing-to-start.pdf'
    // },
    // {
    //     id: 17,
    //     title: 'Introduction to mylife CamAPS FX',
    //     description: 'Introduction to mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-017.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-017-introduction-dk-da.pdf'
    // },
    // {
    //     id: 18,
    //     title: 'mylife CamAPS FX Specifications',
    //     description: 'mylife CamAPS FX Specifications',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-018.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-018-specifications-dk-da.pdf'
    // },
    // {
    //     id: 19,
    //     title: 'mylife CamAPS FX Infographic',
    //     description: 'mylife CamAPS FX Infographic',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-019.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-019-infographic-dk-da.pdf'
    // },
    // {
    //     id: 20,
    //     title: 'Choice of Sensors',
    //     description: 'Choice of Sensors',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-020.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-020-sensors-dk-da.pdf'
    // },
    // {
    //     id: 21,
    //     title: 'Starting mylife CamAPS FX',
    //     description: 'Starting mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-021.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-021-starting-dk-da.pdf'
    // },
    // {
    //     id: 22,
    //     title: 'Patency pulse on mylife CamAPS FX',
    //     description: 'Patency pulse on mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-022.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-022-patency-pulse-dk-da.pdf'
    // },
    // {
    //     id: 23,
    //     title: 'Travelling with mylife CamAPS FX',
    //     description: 'Travelling with mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-023.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-023-travelling-dk-da.pdf'
    // },
    // {
    //     id: 24,
    //     title: 'Managing illness on mylife CamAPS FX',
    //     description: 'Managing illness on mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-024.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-024-illness-dk-da.pdf'
    // },
    // {
    //     id: 25,
    //     title: 'Managing mylife CamAPS FX during surgery, CT or MRI scans',
    //     description: 'Managing mylife CamAPS FX during surgery, CT or MRI scans',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-025.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-025-surgery-dk-da.pdf'
    // },
    // {
    //     id: 26,
    //     title: 'Managing low glucose levels (hypos) with mylife CamAPS FX',
    //     description: 'Managing low glucose levels (hypos) with mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-026.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-026-hypos-dk-da.pdf'
    // },
    // {
    //     id: 27,
    //     title: 'Optimising mylife CamAPS FX',
    //     description: 'Optimising mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-027.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-027-optimising-dk-da.pdf'
    // },
    // {
    //     id: 28,
    //     title: 'Using mylife CamAPS FX at school, nursery or when childminding',
    //     description: 'Using mylife CamAPS FX at school, nursery or when childminding',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-028.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-028-school-dk-da.pdf'
    // },
    // {
    //     id: 29,
    //     title: 'Generating a PDF report',
    //     description: 'Generating a PDF report',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-029.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-029-pdf-report.pdf'
    // },
    // {
    //     id: 30,
    //     title: 'Linking mylife CamAPS FX to Glooko',
    //     description: 'Linking mylife CamAPS FX to Glooko',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-030.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-030-linking-glooko.pdf'
    // }
    {
      id: 1,
      title: "Justering af forudindstillede måltidsstørrelser",
      description: "Justering af forudindstillede måltidsstørrelser",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/adjusting_meal_sizes.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/adjusting_meal_sizes_camdiab_DK.pdf",
      views: 4000,
    },
    {
      id: 2,
      title: "Kalibrering af en sensor",
      description: "Kalibrering af en sensor",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/calibrating_a_sensor.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/calibrating_a_sensor_camdiab_DK.pdf",
      views: 3000,
    },
    {
      id: 3,
      title: "Ændring af kulhydratenheder",
      description: "Ændring af kulhydratenheder",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/changing_carbohydrate_units.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/changing_carbohydrate_units_camdiab_DK.pdf",
      views: 2000,
    },
    {
      id: 4,
      title: "Indtastning af kropsvægt",
      description: "Indtastning af kropsvægt",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/entering_body_weight.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/entering_body_weight_camdiab_DK.pdf",
      views: 31000,
    },
    {
      id: 5,
      title: "Indtastning af total daglig dosis (TDD)",
      description: "Indtastning af total daglig dosis (TDD)",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/entering_total_daily_dose.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/entering_total_daily_dose_camdiab_DK.pdf",
      views: 30000,
    },
    {
      id: 6,
      title: "Indgivelse af en manuel korrektion",
      description: "Indgivelse af en manuel korrektion",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/giving_a_correction.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/giving_a_correction_camdiab_DK.pdf",
      views: 22000,
    },
    {
      id: 7,
      title: "Indgivelse af en måltidsbolus",
      description: "Indgivelse af en måltidsbolus",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/giving_a_meal_bolus.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/giving_a_meal_bolus_camdiab_DK.pdf",
      views: 26000,
    },
    {
      id: 8,
      title: "Hvordan indgiver CamAPS FX insulin?",
      description: "Hvordan indgiver CamAPS FX insulin?",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/how_does_camaps_fx_deliver_insulin.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/how_does_camaps_fx_deliver_insulin_camdiab_DK.pdf",
      views: 35000,
    },
    {
      id: 9,
      title: "Hvordan lærer CamAPS FX?",
      description: "Hvordan lærer CamAPS FX?",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/how_does_camaps_fx_learn.webp",
      pdfUrl:
        "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/how_does_camaps_fx_learn_camdiab_DK.pdf",
      views: 36000,
    },
    {
      id: 10,
      title: "Graviditet",
      description: "Graviditet",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/managing_pregnancy.webp",
      pdfUrl:
        "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/managing_pregnancy_camdiab_DK_mmoll.pdf",
      views: 34000,
    },
    {
      id: 11,
      title: "Parring af pumpe og sensor",
      description: "Parring af pumpe og sensor",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/pairing_pump_and_sensor.webp",
      pdfUrl:
        "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/pairing_pump_and_sensor_camdiab_DK.pdf",
      views: 32000,
    },
    {
      id: 12,
      title: "Åbenhedsimpuls",
      description: "Åbenhedsimpuls",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/patency_pulse.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/patency_pulse_camdiab_DK.pdf",
      views: 1000,
    },
    {
      id: 13,
      title: "Programmering af bolusberegneren",
      description: "Programmering af bolusberegneren",
      date: "20 Jun 2024",
      category: "ypso",
      image:
        "/images/factsheets/thumbnail/programming_bolus_calculator.webp",
      pdfUrl:
        "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/programming_bolus_calculator_camdiab_DK.pdf",
      views: 29000,
    },
    {
      id: 14,
      title: "Advarsler",
      description: "Advarsler",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/setting_alerts.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/setting_alerts_camdiab_DK.pdf",
      views: 21000,
    },
    {
      id: 15,
      title: "Personligt glukosemål (PGT)",
      description: "Personligt glukosemål (PGT)",
      date: "20 Jun 2024",
      category: "ypso",
      image:
        "/images/factsheets/thumbnail/setting_personal_glucose_target.webp",
      pdfUrl:
        "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/setting_personal_glucose_target_camdiab_DK.pdf",
      views: 28000,
    },
    {
      id: 16,
      title: "Deling af diabetesdata",
      description: "Deling af diabetesdata",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/sharing_diabetes_data.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/sharing_diabetes_data_camdiab_DK.pdf",
      views: 20000,
    },
    {
      id: 17,
      title: "Tekniske toptips",
      description: "Tekniske toptips",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/top_technical_tips.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/top_technical_tips_camdiab_DK.pdf",
      views: 33000,
    },
    {
      id: 18,
      title: "Funktionen “Tilføj måltid”",
      description: "Funktionen “Tilføj måltid”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_add_meal.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/using_add_meal_camdiab_DK.pdf",
      views: 25000,
    },
    {
      id: 19,
      title: "Funktionen “Auto mode”",
      description: "Funktionen “Auto mode”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_auto_mode.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/using_auto_mode_camdiab_DK.pdf",
      views: 27000,
    },
    {
      id: 20,
      title: "Funktionen “Blokér”",
      description: "Funktionen “Blokér”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_block.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/using_block_camdiab_DK.pdf",
      views: 19000,
    },
    {
      id: 21,
      title: "Funktionen “Boost”",
      description: "Funktionen “Boost”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_boost.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/using_boost_camdiab_DK.pdf",
      views: 23000,
    },
    {
      id: 22,
      title: "Funktionen “Ease-off”",
      description: "Funktionen “Ease-off”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_ease_off.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/dk_DK/using_ease_off_camdiab_DK.pdf",
      views: 24000,
    },
  ],
};
